<template>
    <div class="row">
        <div class="col-lg-12">
            <card shadow>
                <div class="card-body">
                    <form @submit.prevent="validateFormSecond">
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label>
                                        <span class="text-danger">*</span> Login API Channel ID
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="ตัวอย่าง  165xxxxxxx"
                                        :class="{ 'is-invalid': submitFormSecond && $v.formSecond.loginChannelId.$error }"
                                        v-model="formSecond.loginChannelId"
                                    />
                                    <label
                                        v-if="submitFormSecond && !$v.formSecond.loginChannelId.required"
                                        class="invalid-feedback"
                                    >กรุณากรอก Login API Channel ID</label>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label>
                                        <span class="text-danger">*</span> Login API Channel Secret
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="ตัวอย่าง  595684xxxxxxxxxxxxx"
                                        :class="{ 'is-invalid': submitFormSecond && $v.formSecond.loginChannelSecret.$error }"
                                        v-model="formSecond.loginChannelSecret"
                                    />
                                    <label
                                        v-if="submitFormSecond && !$v.formSecond.loginChannelSecret.required"
                                        class="invalid-feedback"
                                    >กรุณากรอก Login API Channel Secret</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 d-flex justify-content-end">
                                <b-button variant="primary" type="submit">
                                    <i class="fas fa-circle-notch fa-spin" v-if="formSecond.isLoading"></i> เชื่อมต่อ Line OA
                                </b-button>
                            </div>
                        </div>
                    </form>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import {
  required
} from "vuelidate/lib/validators";
import { STEP_SECOND } from '@/plugins/index'

export default {
    props:{
        formSecond:{
            type: Object,
            default: () => {}
        }
    },
    data: () => ({
        submitFormSecond: false
    }),
    validations() {
        return {
            formSecond: {
                loginChannelId: { required },
                loginChannelSecret: { required },
            }
        };
    },
    methods:{
        validateFormSecond(){
            this.submitFormSecond = true;
            this.$v.formSecond.$touch();
            if ( this.$v.formSecond.$invalid ) {
                return false
            }
            this.submitFormSecond = false;

            this.$emit( 'submitForm' , STEP_SECOND )
        }
    }
}
</script>